import AdditionPage from "./Addition"
import EntriesPage from "./Entries"
import EntryPage from "./Entries/Entry"
import OveragesPage from "./Overages"
import ReservesPage from "./Reserves"
import ReservePage from "./Reserves/Reserve"
import ReturnsPage from "./Returns"
import ReturnPage from "./Returns/Return"
import ReturnsEntry from "./ReturnsEntry"
import WarehouseProductsPage from "./WarehouseProducts"
import WarehouseProductPage from "./WarehouseProducts/WarehouseProduct"

const WarehousePages = {
    Entries: EntriesPage,
    Entry: EntryPage,

    Overages: OveragesPage,

    WarehouseProducts: WarehouseProductsPage,
    WarehouseProduct: WarehouseProductPage,

    Reserves: ReservesPage,
    Reserve: ReservePage,

    ReturnsEntry: ReturnsEntry,
    Returns: ReturnsPage,
    Return: ReturnPage,

    Addition: AdditionPage,
}

export default WarehousePages